import React, {useRef, Fragment, useState, useEffect} from 'react';
import {preventDefaultAndStopPropagation} from "utils/global";

type PropsType = {
    disabled?: boolean
    imageUrl?: string | null
    handleFiles: (files: File[]) => Promise<void>
    removeFile?: (e: Event) => void
    multiple?: boolean
    children?:React.ReactNode
}
const FileUploader = (props: PropsType) => {
    const {
        imageUrl = null,
        handleFiles,
        removeFile,
        multiple = false,
        disabled = false
    } = props

    // if the user drop outside the zone, don't open a new tab with the file
    useEffect(() => {
        window.addEventListener("drop", preventDefaultAndStopPropagation());
        window.addEventListener("dragstart", preventDefaultAndStopPropagation());
        window.addEventListener("dragover", preventDefaultAndStopPropagation());

        return () => {
            window.removeEventListener("drop", preventDefaultAndStopPropagation());
            window.removeEventListener("dragstart", preventDefaultAndStopPropagation());
            window.removeEventListener("dragover", preventDefaultAndStopPropagation());
        };
    }, []);


    const hasFile = imageUrl !== null && imageUrl !== ''

    const [dragging, setDragging] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const hiddenFileInput = useRef<HTMLInputElement | null>(null);

    const upload = async (files: File[]) => {
        if (disabled) return
        if (!multiple) {
            files = [files[0]]//get only the first file if not multiple
        }
        setIsLoading(true)
        await handleFiles(files)
        setIsLoading(false)
    }

    const handleClick = (e: any) => {
        if (disabled) return
        if (!hiddenFileInput.current) return
        e.stopPropagation()
        hiddenFileInput.current.click();
    };
    const handleChange = (e: any) => {
        upload(e.target.files)
    };

    const handleRemoveFile = (e: any) => {
        if (disabled) return
        if (!hiddenFileInput.current) return
        e.stopPropagation();
        hiddenFileInput.current.value = ''
        if (removeFile) {
            removeFile(e)
        }
    }


    const onDragLeave = preventDefaultAndStopPropagation((e: any) => {
        if (disabled) return
        setDragging(false);
    });
    const onDrop = preventDefaultAndStopPropagation((e: any) => {
        if (disabled) return
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            upload(e.dataTransfer.files);
            e.dataTransfer.clearData();

            setDragging(false);
        }
    })

    const onDragOver = preventDefaultAndStopPropagation((e: any) => {
        if (disabled) return
        if (!dragging) {
            setDragging(true);
        }
    })

    const onDragEnter = preventDefaultAndStopPropagation((e: any) => {
        if (disabled) return
        if (e.dataTransfer && e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setDragging(true);
        }
    })

    return (
        <Fragment>
            <div
                className={`hover:bg-black-light relative h-full w-full cursor-pointer duration-150 ease-in ${dragging ? 'bg-black-light' : ''}`}
                onDrop={onDrop}
                onDragEnter={onDragEnter}
                onDragOver={onDragOver}
                onDragLeave={onDragLeave}
                onClick={handleClick}
            >
                {props.children}
            </div>
            <input type="file"
                   disabled={disabled}
                   ref={hiddenFileInput}
                   accept="image/jpeg,image/png"
                   onChange={handleChange}
                   multiple={multiple}
                   className="hidden"
            />
        </Fragment>
    );
};
export default FileUploader;
